import type {Offers} from '@/redux/v1/offers/list/models';
import type {ApiError} from '@travel-frontend/state-handling-sdk';

export const FETCH_OFFERS = 'v1/offers/list/FETCH_OFFERS';

type ActionMeta = {
  hotelId: string;
  requestId: string;
};

export type FetchOfferListPending = {
  meta: ActionMeta;
};

export type FetchOfferListSuccess = {
  meta: ActionMeta;
  data: Offers;
};

export type FetchOfferListError = ApiError<
  unknown,
  {
    meta: ActionMeta;
  }
>;
